import React, { Component } from 'react';
import { isEmpty } from "lodash";

import { normalizeStr } from '../../../utils/generalFuncs';
import Dialog from '../../common/Dialog';
import InputText from '../../common/Form';
import { SingleSwitch } from '../../common/RadioAndCheckbox';
import { Box } from '@mui/material';

class PostForm extends Component {
    state = { 
        post_name: this.props.post ? this.props.post.post_name : "",
        post_require_chantier: this.props.post ? this.props.post.post_require_chantier : false,
        post_require_project: this.props.post ? this.props.post.post_require_project : false,
        errors:{
            post_name: "",
        }
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        this.setState({
            [name]: value
        })
    }
    handleCheck = (name) => {
        this.setState({                
            [name]: !this.state[name],
        })
    }
    validate = () => {
        let required = [
            "post_name",
        ]
        
        let noError = true
        let errors = {}
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    
    nameExist = (name, id) => {
        const { POSTS } = this.props;
        let list = []
        list = Object.values(POSTS).filter(item =>  ( 
            (normalizeStr(item.post_name) === normalizeStr(name) ) && 
            (item.post_id !== id) 
        ) )
            
        console.log("Item exist",{list});
        return !isEmpty(list)
    }
    handleSubmit = async () => {
        if(this.validate()){
            let data = {}
            if (this.props.update) {
                data = Object.assign(data, this.props.post)
            }
            data.post_name = this.state.post_name.toUpperCase().replace("'"," ");
            data.post_require_chantier = this.state.post_require_chantier;
            data.post_require_project = this.state.post_require_project;
    
            console.log('====================================');
            console.log({data});
            console.log('====================================');
            
            // check if name exist
            if(this.nameExist(data.post_name, data.post_id) ){
                this.props.notif("error",`Ce poste existe déjà`)
                return
            }

            if(this.props.update){
                await this.props.updatePost(data)
            } else {
                await this.props.newPost(data)  
            }

            if(this.props.STATE.posts.error){
                console.log('====================================');
                console.log("ERROR", this.props.STATE.posts );
                console.log('====================================');
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.posts.error}`)
            } else {
                !this.props.update && this.props.notif("success","Le poste a été créé avec succès")
                this.props.update && this.props.notif("success","Le poste a été modifié avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                close={this.props.handleClose}
                // fullScreen
                title={`${this.props.update ? "Modifier le " : "Créer un nouveau"} Poste`}
                submitAction={this.handleSubmit} 
                disabledSubmit={this.props.STATE.posts.fetching}
                submitTitle={this.props.update ? "Modifier" : "Créer"}
            >
                <InputText
                    required
                    name="post_name" 
                    id="post_name" 
                    value={this.state.post_name} 
                    label="Nom" 
                    placeholder="Nom du poste" 
                    error={this.state.errors.post_name} 
                    onChange={this.handleChange}
                />
                <Box p={1}>
                    <SingleSwitch
                        value={this.state.post_require_project || false} 
                        checked={this.state.post_require_project || false} 
                        label="Ajout Projet Obligatoire"
                        onChange={() => this.handleCheck("post_require_project") }
                    />
                </Box>
                <Box p={1}>
                    <SingleSwitch
                        value={this.state.post_require_chantier || false} 
                        checked={this.state.post_require_chantier || false} 
                        label="Ajout Chantier Obligatoire"
                        onChange={() => this.handleCheck("post_require_chantier") }
                    />
                </Box>
            </Dialog>

        );
    }
}

export default PostForm;